'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = root;

var _reduxSaga = require('redux-saga');

var _actionTypes = require('../constants/actionTypes');

var _data = require('../constants/data');

var _routing = require('../constants/routing');

var _auth = require('./auth');

var _auth2 = _interopRequireDefault(_auth);

var _nodeDescription = require('./nodeDescription');

var _user = require('./user');

var _project = require('./project');

var _project2 = _interopRequireDefault(_project);

var _actions = require('./actions');

var _actions2 = _interopRequireDefault(_actions);

var _title = require('./title');

var _makeWatcher = require('./makeWatcher');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [root].map(regeneratorRuntime.mark);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
/* injects from baggage-loader */

var watchUser = (0, _makeWatcher.makeMonitor)({
  task: _user.getUser,
  event: (0, _reduxSaga.take)([].concat(_toConsumableArray(_actionTypes.ROUTING_ACTIONS_KEYS), [_actionTypes.SET_PROJECT])),
  mapEvent: function mapEvent() {
    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var _ref$params = _ref.params;
    var params = _ref$params === undefined ? {} : _ref$params;
    var getState = arguments[1];

    var _getState = getState();

    var project = _getState.projects.project;


    if (params.userId) {
      return (0, _makeWatcher.start)(params.userId);
    }

    if (project && project.owner) {
      return (0, _makeWatcher.start)(project.owner);
    }

    return (0, _makeWatcher.stop)();
  }
});

var watchProjects = (0, _makeWatcher.makeMonitor)({
  task: _user.getProjects,
  event: (0, _reduxSaga.take)([].concat(_toConsumableArray(_actionTypes.ROUTING_ACTIONS_KEYS), [_actionTypes.SET_AUTHORIZED_USER])),
  mapEvent: function mapEvent(_ref2, getState) {
    var meta = _ref2.meta;

    var _getState2 = getState();

    var user = _getState2.user;
    var routing = _getState2.routing;


    var authorizedUser = user.authorizedUser;
    var params = routing.params;
    var type = routing.type;


    if (authorizedUser && type === _routing.JALAN_INDEX || authorizedUser && authorizedUser.id === (params || {}).userId) {
      return (0, _makeWatcher.start)(authorizedUser.id, 'permissions');
    }

    if (params && params.userId) return (0, _makeWatcher.start)(params.userId, 'public');

    return (0, _makeWatcher.stop)();
  }
});

var watchProject = (0, _makeWatcher.makeMonitor)({
  task: _project2.default,
  event: (0, _reduxSaga.take)(_actionTypes.ROUTING_ACTIONS_KEYS),
  mapEvent: function mapEvent(_ref3) {
    var params = _ref3.params;
    var meta = _ref3.meta;

    if (meta.data.indexOf(_data.PROJECT_DATA) !== -1) {
      return (0, _makeWatcher.start)(params.projectId);
    }
    return (0, _makeWatcher.stop)();
  }
});

var watchNode = (0, _makeWatcher.makeMonitor)({
  task: _nodeDescription.getNodeDescription,
  event: (0, _reduxSaga.take)(_actionTypes.ROUTING_ACTIONS_KEYS),
  mapEvent: function mapEvent(_ref4) {
    var params = _ref4.params;
    var meta = _ref4.meta;

    if (meta.data.indexOf(_data.NODE_DATA) !== -1) {
      return (0, _makeWatcher.start)(params.projectId, params.nodeId);
    }
    return (0, _makeWatcher.stop)();
  }
});

function root(getState) {
  return regeneratorRuntime.wrap(function root$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return [(0, _reduxSaga.call)(watchUser, getState), (0, _reduxSaga.call)(watchProject, getState), (0, _reduxSaga.call)(watchProjects, getState), (0, _reduxSaga.call)(watchNode, getState), (0, _reduxSaga.call)(_auth2.default, getState), (0, _reduxSaga.call)(_actions2.default, getState), (0, _reduxSaga.call)(_title.titleSaga, getState)];

        case 2:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}


//////////////////
// WEBPACK FOOTER
// ./app/sagas/index.js
// module id = 633
// module chunks = 1